var e=e=>{let t="";for(let r=0,a=e.length;r<a;r+=2)t+=String.fromCharCode(parseInt(e.slice(r,r+2),16));return t};export{e as default};